import React from 'react';
import { getImageSrc } from '../../../util';

type Props = {
  className?: string;
  style?: React.CSSProperties;
};

const ProductBannerVideo: React.FC<Props> = ({ className, style }) => {
  return (
    <div className="mt-10 xl:-mt-10 lg:-mt-12 lg:-mr-20 md:mt-10 md:-mr-20 lg:col-span-3">
      <dl className="justify-items-center xl:items-center">
        <div className="w-full md:w-full lg:w-4/5 xl:w-7/8 rounded-2xl mx-auto md:ml-0 lg:ml-20 xl:ml-12">
          <picture>
            <source
              srcSet={getImageSrc('CassavaTerracev1.webp')}
              type={'image/webp'}
            />
            <source
              srcSet={getImageSrc('CassavaTerracev1.jpg')}
              type={'image/jpeg'}
            />
            <img
              className="lazyload rounded-lg object-cover "
              style={{ height: 'auto', width: '100%' }}
              data-src={getImageSrc('CassavaTerracev1.webp')}
              alt="table tab kitchen app screenshot"
            />
          </picture>
        </div>
      </dl>
    </div>
  );
};

export default ProductBannerVideo;
